module.exports = __webpack_public_path__ + "media/images/career_camp/2022/events/_technical-313977d2e4e7f44054465c10d7e5c5f8.svg";